// extracted by mini-css-extract-plugin
export default {"container":"addWells_container__L2LM2","bodyContainer":"addWells_bodyContainer__U7W7b","bodyLeft":"addWells_bodyLeft__HuEUW","bodyRight":"addWells_bodyRight__l7a5Y"};